/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Chat_Dispatched_FailedInputs */

const en_chat_dispatched_failed = /** @type {(inputs: Chat_Dispatched_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed: ${i?.error}`)
};

const fr_chat_dispatched_failed = /** @type {(inputs: Chat_Dispatched_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec : ${i?.error}`)
};

const ms_sg2_chat_dispatched_failed = /** @type {(inputs: Chat_Dispatched_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gagal: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed: {error}" |
*
* @param {Chat_Dispatched_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_dispatched_failed = /** @type {((inputs: Chat_Dispatched_FailedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dispatched_FailedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_dispatched_failed(inputs)
	if (locale === "fr") return fr_chat_dispatched_failed(inputs)
	return ms_sg2_chat_dispatched_failed(inputs)
});